/**
 * Axios timeout configuration
 * - For build time (static generation): longer timeout (60s) to handle slow APIs
 * - For runtime (SSR/client): shorter timeout (30s) for better UX
 */
export const getAxiosTimeout = (): number => {
  // Check if we're in build time
  // Next.js sets NEXT_PHASE during build process
  const isBuildTime =
    process.env.NEXT_PHASE === 'phase-production-build' ||
    (process.env.NODE_ENV === 'production' && typeof window === 'undefined' && !process.env.NEXT_RUNTIME);

  // Use longer timeout during build, shorter for runtime
  // 60s for build time (static generation), 30s for runtime (SSR/client)
  return isBuildTime ? 60000 : 30000;
};

